import React, { useState } from "react";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import "./popup-form.css";
import toast from "react-hot-toast";
import { FaSpinner } from "react-icons/fa";
import { toastOptions } from "../../data/toast-options";

const PopupFormModal = ({ triggerElement }) => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    location: "Calgary",
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const resetForm = () => {
    setFormData({
      name: "",
      phone: "",
      email: "",
      location: "Calgary",
    });
  };

  const handleSubmit = async (e, close) => {
    e.preventDefault();
    setIsLoading(true);

    const AUTH_KEY = process.env.REACT_APP_MAIL_KEY;

    try {
      const templateResponse = await fetch("/email-templates/get-started.html");
      if (!templateResponse.ok) {
        throw new Error("Failed to load email template.");
      }
      let template = await templateResponse.text();

      template = template
        .replace(/{{name}}/g, formData.name)
        .replace(/{{phone}}/g, formData.phone)
        .replace(/{{email}}/g, formData.email)
        .replace(/{{location}}/g, formData.location);

      const textContent = `Name: ${formData.name}\nPhone: ${formData.phone}\nEmail: ${formData.email}\nLocation: ${formData.location}`;

      const response = await fetch(
        `${process.env.REACT_APP_MAIL_SERVER}/send`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: AUTH_KEY,
          },
          body: JSON.stringify({
            fromHost: process.env.REACT_APP_MAIL_USER,
            replyTo: formData.email,
            to: process.env.REACT_APP_EMAIL_TO,
            subject: "Get Started Inquiry",
            text: textContent,
            html: template,
          }),
        }
      );

      if (response.ok) {
        toast.success(
          "Inquiry sent! We'll get back to you shortly.",
          toastOptions
        );
        resetForm();
        close();
      } else {
        const errorText = await response.text();
        toast.error(
          `Couldn't send. Server responded with: ${response.status} - ${errorText}`,
          toastOptions
        );
      }
    } catch (err) {
      console.error("Error sending inquiry:", err);
      toast.error(
        `${err.message} - Couldn't send. Check your network connection.`,
        toastOptions
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Popup
      modal
      closeOnDocumentClick
      closeOnEscape
      overlayStyle={{ background: "rgba(0, 0, 0, 0.5)" }}
      trigger={triggerElement}
      nested
    >
      {(close) => (
        <div className="pmodal">
          <button className="close-btn" onClick={close}>
            &times;
          </button>

          <h2 className="modal-title">Get Started</h2>
          <p className="modal-subtitle">
            Let’s help you begin your immigration journey
          </p>

          <form className="pform" onSubmit={(e) => handleSubmit(e, close)}>
            <div className="form-group">
              <label>Name</label>
              <input
                type="text"
                name="name"
                required
                value={formData.name}
                onChange={handleChange}
                disabled={isLoading}
              />
            </div>

            <div className="form-group">
              <label>Phone Number</label>
              <input
                type="tel"
                name="phone"
                required
                value={formData.phone}
                onChange={handleChange}
                disabled={isLoading}
              />
            </div>

            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                name="email"
                required
                value={formData.email}
                onChange={handleChange}
                disabled={isLoading}
              />
            </div>

            <div className="form-group">
              <label>Location</label>
              <select
                name="location"
                value={formData.location}
                onChange={handleChange}
                disabled={isLoading}
              >
                <option value="Calgary">Calgary</option>
                <option value="St Catherine’s">St Catherine’s</option>
                <option value="GTA">GTA</option>
                <option value="Winnipeg">Winnipeg</option>
              </select>
            </div>

            <button type="submit" className="submit-btn" disabled={isLoading}>
              {isLoading ? (
                <>
                  <FaSpinner
                    className="spinner"
                    style={{
                      marginRight: "8px",
                      animation: "spin 1s linear infinite",
                    }}
                  />
                  Sending...
                </>
              ) : (
                "Submit"
              )}
            </button>
          </form>
        </div>
      )}
    </Popup>
  );
};

export default PopupFormModal;
